module.exports = __webpack_public_path__ + "static/media/align-letter-right.cd8cda78.svg";